import { isTelevisionRuntime } from '../utils/platformCapabilities';

/** Pointer clicks may focus a Web control, but must not pin the chrome open. */
export function shouldHoldPlayerControlsForFocus(): boolean {
  if (isTelevisionRuntime()) return true;
  const activeElement = document.activeElement;
  return activeElement instanceof HTMLElement && activeElement.matches(':focus-visible');
}
